import React, { Component } from "react";
import ModernTabBackgroundItem from "./items/modernBackground";
import ModernTabPatternjItem from "./items/pattern";

export default class ModernTabItems extends Component {
  render() {
    return (
      <ul className="ul-background-select">
        <ModernTabBackgroundItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
        {/* <ModernTabPatternjItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        /> */}
      </ul>
    );
  }
}
